
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"<DRIVING>":"Auto","<DRIVING_HEAVY>":"LKW","<CYCLING>":"Fahrrad","<FOOT>":"Fußgänger","<WHEELCHAIR>":"Rollstuhlgerecht","<AIRBORNE>":"Flugzeug"},"en":{"<DRIVING>":"Driving","<DRIVING_HEAVY>":"Heavy goods vehicle","<CYCLING>":"Cycling","<FOOT>":"Walking","<WHEELCHAIR>":"Wheelchair-accessible","<AIRBORNE>":"Going by airplane"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();